import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '../store'
import { authorizeToken } from './guards'
import CONFIG from '../config'
Vue.use(Router)

const router = new Router({ routes: routes })

// 인증부 확인
router.beforeEach(authorizeToken)

const waitFirebase = () => {
    return new Promise((resolve, reject) => {
        let cnt = 0
        const tmr = setInterval(() => {
            if (store.state.auth.firebaseLoaded) {
                clearInterval(tmr)
                resolve()
            } else if (cnt++ > 500) { // 5second...
                console.log("error cnt > 200", store);
                clearInterval(tmr);
                reject(Error('제한 시간 초과, 인터넷 연결을 확인하세요'))
            }
        }, 10)
    })
}


router.beforeEach((to, from, next) => {
    Vue.prototype.$Progress.start()
    if (CONFIG.USE_FIREBASE) {
        waitFirebase()
            .then(() => next())
            .catch(e => Vue.prototype.$toasted.global.error(e.message))
    } else {
        next()
    }
})

router.afterEach((to, from) => {
    Vue.prototype.$Progress.finish()
})

router.onError(e => {
    Vue.prototype.$Progress.finish()
    Vue.prototype.$toasted.global.error(e.message)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js